module.exports = [
  {
    label: 'Über Triff',
    href: '/about',
  },
  {
    label: 'Jobs',
    href: '/jobs',
  },
  {
    label: 'Kontakt',
    href: '/contact',
  },
  {
    label: 'Margrit',
    href: '/margrit',
  },
  {
    label: 'Datenschutz',
    href: '/privacy',
  },
  {
    label: 'Impressum',
    href: '/imprint',
  },
];
